/** 主题 */
export enum Themes {
  light = 'light',
  dark = 'dark',
  // ...
}

/** 轴向 */
export enum Axes {
  x = 'x',
  y = 'y',
}

/** 方向 */
export enum Direction {
  left = 'left',
  right = 'right',
  top = 'top',
  bottom = 'bottom',
}

/** 加载状态 */
export enum LoadMoreStatus {
  noMore = 'noMore',
  more = 'more',
  loading = 'loading',
}

/** 按钮状态 */
export enum ButtonGroupStatus {
  normal = 'normal',
  normalA = 'normalA',
  active = 'active',
  activeFill = 'activeFill',
  activeFillM4 = 'activeFillM4',
  activeFillCart = 'activeFillCart',
  disabled = 'disabled',
  errorFill = 'errorFill',
  blindboxActivity = 'blindboxActivity',
  blindboxDisabled = 'blindboxDisabled',
  blindboxRecord = 'blindboxRecord',
  blindboxHelp = 'blindboxHelp',
  blindboxPlainA = 'blindboxPlainA',
}

/** 购买模式 */
export enum BuyMode {
  multiple,
  single,
}

/** 优惠类型 */
export enum DiscountType {
  FixedAmount = 'fixedAmount',
  FixedPercent = 'fixedPercent',
  noDiscount = 'noDiscount',
}

/** 满减满赠的满减类型 */
export enum FullDiscountPresentType {
  AmountFullReduction = 'amountFullReduction',
  QuantityFullReduction = 'quantityFullReduction',
  AmountFullPresent = 'amountFullPresent',
}

/** 发货周期类型 */
export enum FrequencyUnit {
  Day = 'day',
  Month = 'month',
  Week = 'week',
}

/** 省市区选择步骤 */
export enum SelectedStep {
  province,
  city,
  town,
  street,
}

/** 订阅状态 */
export enum SubscriptionState {
  underway = 'underway',
  completion = 'completion',
  evaluate = 'evaluate',
  cancel = 'cancel',
  all = '',
}

/** 订单状态 */
export enum OrderState {
  AddingItems = 'AddingItems', //添加商品中(待确认)
  DelayDeliver = 'DelayDeliver', // 延迟发货
  ArrangingPayment = 'ArrangingPayment', // 待付款
  PaymentSettled = 'PaymentSettled', // 等待发货
  Shipped = 'Shipped', // 等待收货 - 全部发完
  Delivered = 'Delivered', // 交易完成
  ConfirmReceiptOfGoods = 'ConfirmReceiptOfGoods', //用户确认收货
  ReviewSettled = 'ReviewSettled', //评价完成
  Cancelled = 'Cancelled', // 交易关闭
}

/** 退款状态 */
export enum RefundState {
  Pending = 'Pending', // 退款中
  Settled = 'Settled', // 退款成功
  Failed = 'Failed', // 退款失败
  Cancel = 'Cancel', // 退款关闭
}

/** 物流状态 */
export enum LogisticState {
  codeError = 'codeError', // 物流单号错误
  noInformation = 'noInformation', // 暂无信息
  pickUp = 'pickUp', // 待揽收
  inTransit = 'inTransit', // 运输中
  signFor = 'signFor', // 已签收
  problemShipment = 'problemShipment', // 问题件
  difficultItem = 'difficultItem', // 疑难物件
  returnSignFor = 'returnSignFor', // 签收退回
}

/** 排序枚举 */
export enum Sort {
  ASC = 'ASC',
  DESC = 'DESC',
  NONE = 'NONE',
}

/** 申请退款来源 */
export enum ApplyRefundSource {
  subscribe,
  normal,
}

/** 礼品状态 */
export enum GiftState {
  created = 'created', // 创建未开启
  draw = 'draw', // 开启未领取
  pendingShipment = 'pendingShipment', // 领取待发货
  completed = 'completed', // 发货完成
  all = '',
}

/** 礼品类型 */
export enum GiftBoxItemType {
  product = 'product',
  redBag = 'redBag',
}

/**
 * 页面入口来源
 * 用以一些场景做特殊交互，比如支付完成跳往订阅详情，返回时需连续返回2级路由
 */
export enum EntrySources {
  none = 'none',
  placeOrder = 'placeOrder',
  subscribeList = 'subscribeList',
  detail = 'detail',
}

/** 资源类型 */
export enum ResourceType {
  video = 'VIDEO',
  image = 'IMAGE',
}

/** 评论状态 */
export enum CommentState {
  wait,
  yet,
}

/** 自定义图片跳转类型 */
export enum CustomJumpType {
  // url
  url = 'url',
  // 商品详情
  productDetails = 'productDetails',
  // 不跳转
  blank = 'blank',
  // 活动页
  activePage = 'activePage',
  // 优惠券
  coupon = 'coupon',
  // 满减活动
  fullDiscount = 'fullDiscount',
  // 第X件Y折活动
  discountByQuantity = 'discountByQuantity',
  // 加价购活动
  purchasePremium = 'purchasePremium',
  // 打包一口价
  packageDiscountActivity = 'packageDiscount',
  // 会员卡页面
  memberShipPlan = 'memberShipPlan',
  // 小程序
  smallProgram = 'smallProgram',
  // 优惠券礼包
  couponBundle = 'couponBundle',
  // 会员列表
  membershipPlanListPage = 'membershipPlanListPage',
  // 签到页
  checkinPage = 'checkinPage',
  // 盲盒活动页
  blindBoxActivity = 'blindBoxActivity',
  // 积分商城
  PointsMall = 'pointsMall',
  // 论坛
  forum = 'forum',
  // 论坛话题
  forumTag = 'forumTag',
  // 购物金抵扣
  shoppingCreditsDeduction = 'shoppingCreditsDeduction',
  // 购物金可得
  shoppingCreditsClaim = 'shoppingCreditsClaim',
}

/** 上传资源状态 */
export enum UploadState {
  pending = 'pending',
  finish = 'finish',
  error = 'error',
}

/** 微信支付类型 */
export enum WeChatPaymentType {
  wechatProgram = 'wechatProgram',
  wechatOfficialAccounts = 'wechatOfficialAccounts',
}

/** 删除订单结果状态 */
export enum DeletionResult {
  DELETED = 'DELETED',
  NOT_DELETED = 'NOT_DELETED',
}

/** 下单类型 */
export enum PlaceOrderType {
  // 购物车
  shoppingTrolley = 'shoppingTrolley',
  // 预下单
  outrightPurchase = 'outrightPurchase',
  // 直接购买
  regularOrder = 'regularOrder',
  // 积分兑换
  pointsExchange = 'pointsExchange',
  // 直接购买 转 购物车
  _regularOrderToShoppingTrolley = '_regularOrderToShoppingTrolley',
}

/** 自定义页面类型 */
export enum CustomPageType {
  homePage = 'homePage',
  commodityGroupPage = 'commodityGroupPage',
  activePage = 'activePage',
  membershipPlanPage = 'membershipPlanPage',
  checkinPage = 'checkinPage',
}

/** 自定义组件类型 */
export enum CustomComponentType {
  banner = 'banner',
  picture = 'picture',
  product = 'product',
  productItems = 'productItems',
  checkin = 'checkin',
  countdown = 'countdown',
  shoppingCredits = 'shoppingCredits',
  customerLevel = 'customerLevel',
}

/** 自定义商品分组类型 */
export enum ProductGroupType {
  topGroup = 'topGroup',
  leftGroup = 'leftGroup',
}

/** 售后历史类型 */
export enum AfterSaleHistoryType {
  // 提交售后申请
  Submit = 'submit',
  // 修改售后申请
  UpdateSubmit = 'updateSubmit',
  // 同意申请并发送退货地址
  ShippingReturnAddress = 'shippingReturnAddress',
  // 填写退货物流
  FillOutReturnLogistics = 'fillOutReturnLogistics',
  // 修改物流单号
  UpdateReturnLogistics = 'updateReturnLogistics',
  // 确认收货并发货
  ConfirmReceiptAndDelivery = 'confirmReceiptAndDelivery',
  // 同意仅退款
  AgreeToRefundOnly = 'agreeToRefundOnly',
  // 拒绝退款
  RefusalOfRefund = 'refusalOfRefund',
  // 确认收货并退款
  ConfirmReceiptAndRefund = 'confirmReceiptAndRefund',
  // 取消售后
  CancelAfterSale = 'cancelAfterSale',
  // 售后完成
  Complete = 'complete',
}

/** 售后状态 */
export enum AfterSaleState {
  // 提交申请
  submit = 'submit',
  // 商家同意申请,等待用户退货
  waitingForDelivery = 'waitingForDelivery',
  // 用户已退货,等待商家收货
  goodsToBeReceived = 'goodsToBeReceived',
  // 商家确认收货并发货
  confirmReceiptAndDelivery = 'confirmReceiptAndDelivery',
  // 商家拒绝退款
  refusalOfRefund = 'refusalOfRefund',
  // 拒绝收货
  refusalOfGoods = 'refusalOfGoods',
  // 商家同意退款
  agreeToRefund = 'agreeToRefund',
  // 退款成功
  successfulRefund = 'successfulRefund',
  // 售后完成
  complete = 'complete',
  // 售后取消
  cancel = 'cancel',
}

/** 售后类型 */
export enum AfterSaleMode {
  // 仅退款
  refundOnly = 'refundOnly',
  // 退货退款
  refundForReturnedGoods = 'refundForReturnedGoods',
  // 换货
  exchangeGoods = 'exchangeGoods',
}

/** 物流类型 */
export enum LogisticsType {
  // 退货
  returnGoods = 'returnGoods',
  // 发货
  deliverGoods = 'deliverGoods',
}

/** 协商记录操作者类型 */
export enum OperatorType {
  user = 'user',
  channel = 'channel',
  platform = 'platform',
}

/** 会员状态 */
export enum MemberState {
  not = 'not',
  unactivated = 'unactivated',
  normal = 'normal',
  expired = 'expired',
  returnTheCard = 'returnTheCard',
}

/** 会员卡有效期 */
export enum ValidityPeriodType {
  // 长期有效
  longTime = 'longTime',
  // 有效天数
  validDays = 'validDays',
  // 时间段
  temporalInterval = 'temporalInterval',
}

/** 优惠券状态 */
export enum UserCouponState {
  // 未使用
  unused = 'unused',
  // 过期
  expire = 'expire',
  // 已经使用
  haveUsed = 'haveUsed',
  // 已锁定（当前优惠券已被订单使用）
  lock = 'lock',
  // 未开始
  notStarted = 'notStarted',
}

/** 优惠券类型 */
export enum CouponType {
  // 满减
  fullSubtraction = 'fullSubtraction',
  // 折扣
  discount = 'discount',
  // 商品兑换
  exchange = 'exchange',
}

/** 优惠券折扣 满足类型 */
export enum PreferentialType {
  // 满足条件可用
  satisfy = 'satisfy',
  // 无门槛
  thresholdFree = 'thresholdFree',
}

/** 适用商品类型 */
export enum ApplicableType {
  all = 'all',
  availableGoods = 'availableGoods', // 包含
  unusableGoods = 'unusableGoods', // 不包含
}

/** 分享类型 */
export enum SharingType {
  QRCode = 'QRCode',
  link = 'link',
  friend = 'friend',
  H5Link = 'H5',
}

/** 外部环境跳转进入应用的类型 */
export enum OutsideComein {
  // 优惠卷
  coupon = 'coupon',
  // 优惠卷礼包
  couponBundle = 'couponBundle',
  // 加价购
  purchasePremium = 'purchasePremium',
  // 分销
  distribution = 'distribution',
  // 首页
  homePage = 'homePage',
  // 商品组页面
  commodityGroupPage = 'commodityGroupPage',
  // 自定义页面 - 活动页
  customPage = 'customPage',
  // 会员
  memberShipPlan = 'memberShipPlan',
  // 商品
  product = 'product',
  // 折扣活动 第X件Y折
  discountActivity = 'discountActivity',
  // 打包一口价
  packageDiscountActivity = 'packageDiscountActivity',
  // 满减活动 满减送
  fullDiscountActivity = 'fullDiscountActivity',
  // 任选满赠
  selectiveGiftActivity = 'selectiveGiftActivity',
  // 礼品卡
  giftCard = 'giftCard',
  // 搜索结果
  searchResult = 'searchResult',
  // 搜索
  search = 'search',
  // 会员中心
  memberCenter = 'memberCenter',
  // 签到页
  checkinPage = 'checkinPage',
  // 盲盒页
  blindBoxActivity = 'blindBoxActivity',
  // 积分商城
  PointsMall = 'pointsMall',
  // 论坛
  forum = 'forum',
  // 话题
  forumTag = 'forumTag',
  // 购物金抵扣
  shoppingCreditsDeduction = 'shoppingCreditsDeduction',
  // 购物金可得
  shoppingCreditsClaim = 'shoppingCreditsClaim',
  // 无参数
  none = 'none',
}

/** 搜索热词类型 */
export enum HotWordType {
  ordinary = 'ordinary',
  choiceness = 'choiceness',
}

/** 优惠活动类型 */
export enum PromotionType {
  // 会员卡折扣
  member = 'member',
  // 会员卡折扣
  memberPrice = 'memberPrice',
  // 加价购 - 换购
  purchaseAtAPremium = 'purchaseAtAPremium',
  // 优惠卷 - 暂无
  coupon = 'coupon',
  // 限时折扣 = x件x折
  discountActivity = 'discountActivity',
  // 满减送活动
  fullDiscountPresent = 'fullDiscountPresent',
  // 打包一口价
  packageDiscount = 'packageDiscount',
  // 实付满赠
  actuallyPaid = 'actuallyPaid',
  // 任选满赠
  selectiveGift = 'selectiveGift',
  // 支付有礼
  paymentReward = 'paymentReward',
  // 积分兑换
  pointsExchange = 'pointsExchange',
  // 盲盒活动
  BlindBox = 'blindBox',
  // 购物金抵扣
  shoppingCreditsDeduction = 'shoppingCreditsDeduction',
  // 购物金可得
  shoppingCreditsClaim = 'shoppingCreditsClaim',
  // 会员相关总优惠 - 额外添加
  _memberRelatedTotal = '_memberRelatedTotal',
}

/** 额外私有定义 - 优惠活动类型 */
export enum _PromotionType {
  DiscountActivity = 'DiscountActivity',
  FullDiscountPresent = 'FullDiscountPresent',
  PurchasePremium = 'PurchasePremium',
  PackageDiscount = 'PackageDiscount',
  SelectiveGiftActivity = 'SelectiveGiftActivity',
  ShoppingCreditsClaimActivity = 'ShoppingCreditsClaimActivity',
  ShoppingCreditsDeductionActivity = 'ShoppingCreditsDeductionActivity',
}

/** 购买模式类型 */
export enum PurchasePattern {
  // 普通的
  Ordinary = 'ordinary',
  // 赠品
  Gift = 'gift',
  // 加价购
  PurchasePremium = 'purchasePremium',
}

/** 精选配置商品key */
export enum SettingKey {
  personalCenterProductGroup = 'personalCenterProductGroup',
  shoppingCartProductGroup = 'shoppingCartProductGroup',
  searchResultProductGroup = 'searchResultProductGroup',
  memberCardProductGroup = 'memberCardProductGroup',
  productDetailProductGroup = 'productDetailProductGroup',
  couponPageProductGroup = 'couponPageProductGroup',
  canBackProductDetailPage = 'canBackProductDetailPage',
  forumRecommendProductGroup = 'forumRecommendProductGroup',
}

/** 限购类型 */
export enum LimitType {
  // 无限制
  unlimited = 'unlimited',
  // 天
  day = 'day',
  // 周
  week = 'week',
  // 月
  month = 'month',
  // 年
  year = 'year',
  // 永久
  forever = 'forever',
  // 订单
  order = 'order',
}

// 页面类型定义
export enum trackPageType {
  home = 'HomePage',
  classfiy = 'ProductlistPage',
  activity = 'ActivityPage',
  product = 'products',
}

/** 定时开售类型 */
export enum PutOnSaleType {
  // 立即开售
  immediate = 'immediate',
  // 定时开售
  scheduled = 'scheduled',
  // 手动开售
  manual = 'manual',
}

/** 自定义页面组件列数展示类型 */
export enum CustomerCompColumnType {
  oneColumn = 'oneColumn',
  towColumn = 'towColumn',
  threeColumn = 'threeColumn',
}

/** 礼品卡状态 */
export enum GiftCardState {
  shelf = 'shelf',
  takeOffTheShelf = 'takeOffTheShelf',
}

/** 礼品卡订单状态 */
export enum MembershipGiftCardOrderState {
  toBePaid = 'toBePaid',
  paid = 'paid',
  cancelled = 'cancelled',
  refunded = 'refunded',
  partiallyRefunded = 'partiallyRefunded',
}

/** 页面来源key （后续优化：有空可以和EntrySource进行合并） */
export enum DistributorCenterPageKey {
  order = 'order',
  product = 'product',
  customer = 'customer',
  purchaseCard = 'purchaseCard',
}

/** 分销员中心用户类型 */
export enum DistributorCenterCustomerType {
  allCustomer = 'allCustomer',
  effectiveCustomer = 'effectiveCustomer',
  orderCustomer = 'orderCustomer',
  invalidCustomer = 'invalidCustomer',
}

/** 商品类型 */
export enum ProductType {
  /** 真实商品 */
  Ordinary = 'ordinary',
  /** 虚拟商品 */
  Virtual = 'virtual',
}

/** 虚拟商品类型 */
export enum VirtualTargetType {
  /** 优惠券 */
  Coupon = 'coupon',
  /** 会员卡 */
  MemberCard = 'memberCard',
}

/** 商品限购组类型 */
export enum ProductExclusionGroupType {
  // 仅随单
  mustCombineWithNonGroup = 'mustCombineWithNonGroup',
  // 可组合购买 - 免优优惠
  canCombineWithGroup = 'canCombineWithGroup',
  // 不可组合购买 - 单拍付邮
  noCombineWithGroup = 'noCombineWithGroup',
}

/** 开卡用户状态 */
export enum DistributorCenterMemberStateInput {
  all = 'all',
  unactivated = 'unactivated',
  normal = 'normal',
  expired = 'expired',
  returnTheCard = 'returnTheCard',
}

/** 积分明细加减符号 */
export enum SymbolType {
  in = 'in',
  out = 'out',
  frz = 'frz',
}

/** 积分商品兑换类型 */
export enum ExchangeConditionType {
  unifiedExchangeRatio = 'unifiedExchangeRatio',
  customExchangeRatio = 'customExchangeRatio',
}

/** 跳过（无需）支付的类型 */
export enum SkipOverPaymentType {
  memberShipCard = 'memberShipCard',
  integralExchange = 'integralExchange',
}

/** 请求异常状态码 */
export enum FetchAbnormalCodes {
  // 优惠券礼包错误
  COUPON_BUNDLE_RECEIVE_ERROR = 'COUPON_BUNDLE_RECEIVE_ERROR',
  // 操作错误
  OPERATION_ERROR = 'OPERATION_ERROR',
  // 限购组错误
  EXCLUSION_GROUP_ERROR = 'EXCLUSION_GROUP_ERROR',
  // 积分不足
  POINTS_NOT_ENOUGH_ERROR = 'POINTS_NOT_ENOUGH_ERROR',
  // 积分活动已失效
  POINTS_PROMOTION_EXPIRED_ERROR = 'POINTS_PROMOTION_EXPIRED_ERROR',
  // 积分商品不能直接购买
  POINTS_PRODUCT_CANNOT_BUY_ERROR = 'POINTS_PRODUCT_CANNOT_BUY_ERROR',
  // 积分订单只能存在一个商品
  POINTS_ONLY_ONE_PER_ORDER_ERROR = 'POINTS_ONLY_ONE_PER_ORDER_ERROR',
  // 商品收货地址不支持配送
  PRODUCT_REGION_RESTRICTION_ERROR = 'PRODUCT_REGION_RESTRICTION_ERROR',
}

/** 积分兑换来源类型 */
export enum PointsSourceType {
  order = 'order',
  afterSale = 'afterSale',
  youZanSync = 'youZanSync',
  pointsExchange = 'pointsExchange',
  pointsRefund = 'pointsRefund',
}

/** 签到奖励类型 */
export enum SignInPrizeType {
  points = 'points',
  coupon = 'coupon',
}

/** 盲盒活动状态 */
export enum BlindBoxActivityStatus {
  // 正常进行中
  normal = 'normal',
  // 失效
  failure = 'failure',
  // 未开始
  notStarted = 'notStarted',
  // 已结束
  haveEnded = 'haveEnded',
}

/** 开盒购买记录状态 */
export enum BlindBoxBuyStatus {
  // 待开启
  pendingOpen = 'pendingOpen',
  // 助力中
  assisting = 'assisting',
  // 已提货
  delivered = 'delivered',
  // 待提货
  pendingDelivery = 'pendingDelivery',
  // 已退款
  refunded = 'refunded',
}

/** 来源类型 */
export enum CustomerSourceType {
  blindBoxAssist = 'blindBoxAssist',
  blindBoxActivity = 'blindBoxActivity',
}

/** 帖子类型 */
export enum ForumPostType {
  long = 'long',
  short = 'short',
}

/** 帖子状态 */
export enum ForumPostStatus {
  Draft = 'draft',
  Pending = 'pending',
  Published = 'published',
  Refused = 'refused',
  none = '',
}

/** 论坛主页tab类型 */
export enum ForumMainTabType {
  hot = 'hot',
  new = 'new',
  audit = 'audit',
  draft = 'draft',
  all = 'all',
}

/** 帖子通知类型 */
export enum ForumNotificationType {
  upvote = 'upvote',
  reply = 'reply',
  mention = 'mention',
  all = 'all',
}

/** 论坛帖子排行榜时间类型 */
export enum ForumPostHotDateType {
  daily = 'daily',
  weekly = 'weekly',
  monthly = 'monthly',
  alltime = 'alltime',
}

/** 笔记话题活动状态 */
export enum ForumTagStatus {
  active = 'active',
  inactive = 'inactive',
}

/** 笔记话题论坛活动状态 */
export enum ForumActivityStatus {
  notStarted = 'notStarted',
  normal = 'normal',
  haveEnded = 'haveEnded',
  failure = 'failure',
}

/** 分享设置页面key */
export enum ShareSettingPageKey {
  pointsMall = 'pointsMall',
  pointsCheckin = 'pointsCheckin',
  forumPost = 'forumPost',
}

/** 虚拟币类型 */
export enum VirtualCurrencyCode {
  shoppingCredits = 'shoppingCredits',
}

/** 虚拟币兑换来源类型 */
export enum VirtualCurrencySourceType {
  /** 下单返 */
  order = 'order',
  /** 回收 */
  reclaimed = 'reclaimed',
  /** 外部系统 */
  externalSystem = 'externalSystem',
  /** 管理员操作 */
  adminOperation = 'adminOperation',
  /** 订单扣减 */
  orderDeduction = 'orderDeduction',
  /** 售后退回 */
  returned = 'returned',
  /** 商家自愿退款退货 */
  merchantVoluntaryRefundReturn = 'merchantVoluntaryRefundReturn',
  /** 商家自愿回收 */
  merchantVoluntaryReclaimed = 'merchantVoluntaryReclaimed',
  /** 到期 */
  expired = 'expired',
  /** 会员等级 */
  ustomerLevel = 'ustomerLevel',
}

/** 购物金条件类型 */
export enum ShoppingCreditConditionType {
  amountFullReduction = 'amountFullReduction',
  quantityFullReduction = 'quantityFullReduction',
}

/** 会员等级权益类型 */
export enum MembershipLevelBenefitsType {
  coupon = 'coupon',
  shoppingCredit = 'shoppingCredit',
  point = 'point',
}
